import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux'

import logo from './icons/logo.svg';
import './App.css';
import './App.sass';
import Icon from './compUtils/Icon';

import ProfilePage from './compPages/ProfilePage';
import ProfilesPage from './compPages/ProfilesPage';
import MoviePage from './compPages/MoviePage';
import MoviesPage from './compPages/MoviesPage';
import ReviewsPage from './compPages/ReviewsPage';
import RegisterPage from './compPages/RegisterPage';
import LoginPage from './compPages/LoginPage';

import { Link } from "react-router-dom";

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from './redux/hooks'

import { logout } from './redux/reducers'


import {

  Route,
  Switch,
} from "react-router-dom";

function App(props) {


  const images = ['1917.jpg', 'her.jpg', 'indy3.jpg', 'the-general.jpg', 'oldboy.jpg', 'gladiator.jpg', 'django.jpg']
  const [bkgImage, setBkgImage] = useState(images[Math.floor(Math.random() * images.length)])

  const dispatch = useDispatch()

  const objectId = "/api/movies/"
  const moviesSelector = useObjectSelector(objectId)
  const movies = getObject(objectId, moviesSelector, dispatch)

  const loginState = useSelector(store => store.loginReducer)

  const [searchString, setSearchString] = useState('')
  const [dropdownSearch, setDropdownSearch] = useState({ dropped: false, list: [] })

  const changeName = (event) => {
    setSearchString(event.target.value)
  }


  useEffect(() => {
    if (searchString === '') {
      setDropdownSearch({ dropped: false, list: [] })
      return
    }
    if (movies() === 'UNKNOWN') return
    const filteredMovies = movies().filter(movie => movie.name.toUpperCase().startsWith(searchString.toUpperCase())) //movie.title.toUpperCase().startsWith() === searchString.toUpperCase()
    setDropdownSearch({ dropped: true, list: filteredMovies })
  }, [searchString]);



  return (
    <div >



      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <div class="navbar-item" >
            <img src={logo} alt="" />
          </div>

          <label
            role="button"
            className="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            htmlFor="nav-toggle-state"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </label>
        </div>
        <input type="checkbox" id="nav-toggle-state" />


        <div id="navbarBasicExample" class="navbar-menu">
          <div class="navbar-start">
            <div class="navbar-item">
              <Link to="/">Actualités</Link>
            </div>
            {
              loginState.logged ?
                <div class="navbar-item">
                  <Link to={"/profiles/" + loginState.profile.id}>Mon Profil</Link>
                </div>
                :
                ""
            }
            <div class="navbar-item">
              <Link to="/movies">Films</Link>
            </div>
            <div class="navbar-item">
              <Link to="/profiles">Utilisateurs</Link>
            </div>

          </div>

          <div class="navbar-end">

            <div class="navbar-item">
              <div class="dropdown is-active">
                <div class="dropdown-trigger">
                  <div class="field">
                    <p class="control is-expanded has-icons-right">
                      <input class="input" type="search" placeholder="Search..." onChange={changeName} />
                      <span class="icon is-small is-right"><Icon name="search" /></span>
                    </p>
                  </div>
                </div>

                {dropdownSearch.dropped ?
                  <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      {dropdownSearch.list.map((movie) => (
                        <div class="dropdown-item"><Link to={"/movies/" + movie.id} onClick={() => { setDropdownSearch({ dropped: false, list: [] }) }}>{movie.name}</Link></div>
                      ))}
                    </div>
                  </div>
                  :
                  ""
                }
              </div>
            </div>


            {
              loginState.logged ?

                <div class="navbar-item has-dropdown is-hoverable">
                  <a class="navbar-link">
                    <figure class="image is-32x32">
                      <img class="is-rounded" src={loginState.profile.thumbnail.source} alt={loginState.profile.thumbnail.name} />
                    </figure>
                  </a>

                  <div class="navbar-dropdown">
                    <a class="navbar-item" onClick={() => { dispatch(logout()) }}>
                      Log out
                      </a>
                  </div>
                </div>

                :
                <div class="navbar-item">
                  <div class="buttons">
                    <div class="button is-primary">
                      <Link to="/login" class="buttonLink"><strong>Login</strong></Link>
                    </div>
                  </div>
                </div>
            }
          </div>

        </div>


      </nav>

      <div id="viewer" style={{ "backgroundImage": 'url(/wallpapers/' + bkgImage + ')' }}>

        <Switch>
          <Route exact path="/" children={<ReviewsPage />} />
          <Route path="/profiles/:id" children={<ProfilePage />} />
          <Route path="/profiles/" children={<ProfilesPage />} />
          <Route path="/movies/:id" children={<MoviePage />} />
          <Route path="/movies/" children={<MoviesPage />} />
          <Route path="/register/" children={<RegisterPage />} />
          <Route path="/login/" children={<LoginPage />} />
          <Route>PAGE NOT FOUND</Route>
        </Switch>

      </div>


    </div>
  );
}

export default App;
